/**
 * Produktseite: Bildgalerie, Variantenwahl, Preis-Synchronisation,
 * mobile Kaufleiste.
 *
 * Alles laeuft ueber [data-product-root] und ist damit auf EIN Produkt
 * begrenzt. Mehrere Produkte auf einer Seite schreiben sich nicht gegenseitig
 * um — das war der zweite Fehler aus dem Experience-Pass.
 */
(function () {
  'use strict';

  /**
   * Geldbetrag in der Schreibweise des Hauses: "€ 83,00".
   *
   * Muss mit snippets/price.liquid uebereinstimmen — sonst springt die
   * Schreibweise beim Variantenwechsel, weil der erste Preis aus Liquid kommt
   * und jeder weitere von hier. Dazu gehoert auch der Tausenderpunkt: Liquid
   * schreibt „€ 1.234,56", ohne ihn stuende hier „€ 1234,56".
   */
  function formatMoney(cents) {
    var teile = (cents / 100).toFixed(2).split('.');
    var ganz = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€ ' + ganz + ',' + teile[1];
  }

  /* Bezugsgroesse des Grundpreises, ebenfalls wie in price.liquid: "1 l"
     liest sich als "Liter". */
  function formatBezug(measurement) {
    if (!measurement) return '';
    var menge = measurement.reference_value;
    var einheit = measurement.reference_unit;
    if (menge !== 1) return menge + ' ' + einheit;
    if (einheit === 'l') return 'Liter';
    if (einheit === 'kg') return 'Kilogramm';
    return einheit;
  }

  /* ---------- Bildgalerie ----------
     Der Index ist die Position im DOM: Das erste Bild gehoert zum ersten
     Umschalter. Deshalb braucht das Markup keine Index-Attribute. */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var media = gallery.parentElement;
    var items = gallery.querySelectorAll('.pdp-gallery__item');
    var thumbs = media ? media.querySelectorAll('[data-gallery-thumb]') : [];
    if (items.length < 2 || !thumbs.length) return;

    function zeige(index) {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      /* Das Schlagwort gehoert zur Flasche und tritt bei Fotos zurueck —
         das entscheidet CSS anhand dieses Attributs. */
      gallery.setAttribute('data-active', String(index));
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        zeige(index);
      });
    });

    /* Erst jetzt, wo die Umschalter etwas tun, werden sie sichtbar. Eigene
       Klasse statt `.js` am <html>: Die setzt effects.js nur, wenn
       Scroll-Animationen laufen — bei „Bewegung reduzieren" blieb die Leiste
       sonst dauerhaft versteckt. */
    var leiste = media.querySelector('.pdp-thumbs');
    if (leiste) leiste.classList.add('is-ready');
  });

  /* ---------- Variantenwahl ---------- */
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var dataEl = root.parentElement.querySelector('[data-variant-data]');
    var select = root.querySelector('[data-variant-select]');
    var priceBlock = root.querySelector('[data-price-block]');
    var addButton = root.querySelector('[data-add-button]');

    if (!dataEl || !select) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    function currentSelection() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-input]:checked'),
        function (input) {
          return input.value;
        }
      );
    }

    function findVariant(selection) {
      return variants.find(function (variant) {
        return selection.every(function (value, index) {
          return variant.options[index] === value;
        });
      });
    }

    function render(variant) {
      if (!variant) return;

      select.value = variant.id;

      if (priceBlock) {
        var priceEl = priceBlock.querySelector('[data-price]');
        var compareEl = priceBlock.querySelector('[data-compare-price]');
        var unitEl = priceBlock.querySelector('[data-unit-price]');

        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        /* Der Grundpreis ist bei Wein Pflicht und variantenabhaengig: Die
           Magnum kostet pro Liter mehr als die 0,75 l. Er MUSS deshalb
           mitwandern, sonst steht eine falsche Pflichtangabe auf der Seite. */
        if (unitEl) {
          if (variant.unit_price && variant.unit_price_measurement) {
            unitEl.textContent =
              formatMoney(variant.unit_price) + ' / ' + formatBezug(variant.unit_price_measurement);
            unitEl.hidden = false;
          } else {
            unitEl.hidden = true;
          }
        }
      }

      [addButton, document.querySelector('[data-sticky-button]')].forEach(function (button) {
        if (!button) return;
        button.disabled = !variant.available;
      });

      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      /* URL mitfuehren, damit Teilen und Neuladen die gewaehlte Variante behalten. */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-option-input]')) return;
      render(findVariant(currentSelection()));
    });
  });

  /* ---------- Mobile Kaufleiste ----------
     Erscheint, sobald der Kaufblock oben rausgescrollt ist. */
  var sticky = document.querySelector('[data-sticky-atc]');
  var buyBlock = document.querySelector('.pdp-buy');

  if (sticky && buyBlock && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.hidden = entry.isIntersecting;
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-120px 0px 0px 0px' }
    );

    observer.observe(buyBlock);
  }
})();
